<mat-menu #menu="matMenu">
  @for (nodeType of nodeTypes; track nodeType.id) {
  <button mat-menu-item (click)="onSelect(nodeType.name?.toLowerCase())" [matTooltip]="nodeType.tooltip || ('Create ' + nodeType.name)" matTooltipPosition="right">
    <p-chip
      class="item-type-chip"
      [label]="nodeHelper.getSelectedNodeTypeLabelByNodeTypeId(nodeType.id)"
      [style.backgroundColor]="nodeHelper.getSelectedNodeTypeBackgroundColorForHeaderByNodeTypeId(nodeType.id) || '#F5F5F5'"
      [style.color]="nodeHelper.getSelectedNodeTypeColorForHeaderByNodeTypeId(nodeType.id) || '#000000'"
      [ngStyle]="nodeHelper.getNodeTypeBorderStyle(nodeType.id)"
      [style.cursor]="'pointer'">
    </p-chip>
  </button>
  }
</mat-menu>
